import React, { useState } from 'react';

const AdminDebugNewsletters = ({ password }) => {
  const [loading, setLoading] = useState(false);
  const [debugData, setDebugData] = useState(null);
  const [error, setError] = useState('');

  const handleDebug = async () => {
    setLoading(true);
    setError('');
    setDebugData(null);

    try {
      const response = await fetch('/api/debug-newsletters', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-admin-password': password
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to debug newsletters');
      }

      setDebugData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 32 }}>
      <h2>Debug Newsletter Content</h2>
      <p style={{ marginBottom: 24, color: '#666' }}>
        This tool will inspect all newsletters and show you their content structure to help debug the cleanup process.
      </p>

      <button
        onClick={handleDebug}
        disabled={loading}
        style={{
          padding: '12px 24px',
          fontSize: 16,
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: 6,
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? 'Loading...' : 'Debug Newsletters'}
      </button>

      {error && (
        <div style={{ 
          marginTop: 16, 
          padding: 12, 
          backgroundColor: '#f8d7da', 
          color: '#721c24', 
          borderRadius: 4,
          border: '1px solid #f5c6cb'
        }}>
          Error: {error}
        </div>
      )}

      {debugData && (
        <div style={{ marginTop: 24 }}>
          <h3>Debug Results</h3>
          <p><strong>Total Newsletters:</strong> {debugData.totalNewsletters}</p>
          
          {debugData.debugInfo.map((newsletter, index) => (
            <div key={index} style={{ 
              marginTop: 16, 
              padding: 16, 
              border: '1px solid #ddd', 
              borderRadius: 4,
              backgroundColor: '#f9f9f9'
            }}>
              <h4>Newsletter {index + 1}</h4>
              <p><strong>Subject:</strong> {newsletter.subject}</p>
              <p><strong>Has Archive Link:</strong> {newsletter.hasArchiveLink ? 'Yes' : 'No'}</p>
              <p><strong>Archive Link Matches:</strong> {newsletter.archiveLinkMatch}</p>
              <p><strong>Content Preview:</strong></p>
              <pre style={{ 
                backgroundColor: '#fff', 
                padding: 8, 
                borderRadius: 4, 
                fontSize: 12,
                overflow: 'auto',
                maxHeight: 200
              }}>
                {newsletter.contentPreview}
              </pre>
              <div style={{ marginTop: 8 }}>
                <p><strong>Full Content:</strong></p>
                <pre style={{ 
                  backgroundColor: '#fff', 
                  padding: 8, 
                  borderRadius: 4, 
                  fontSize: 10,
                  overflow: 'auto',
                  maxHeight: 300,
                  whiteSpace: 'pre-wrap'
                }}>
                  {newsletter.fullContent ? newsletter.fullContent.substring(0, 1000) : 'No content'}
                </pre>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDebugNewsletters; 